module.exports = __webpack_public_path__ + "img/TG.b5aba65b.svg";